import {Parser, ParseResult} from "./parser";

const matcher = /{icon-([\w\d]*)}/;

export const iconParser: Parser = {
    matches(markup: string, startIndex: number): boolean {
        const match = markup.substring(startIndex).match(matcher);
        return match !== null && match.index === 0;
    },

    parse(markup: string, startIndex: number): ParseResult {
        const match = markup.substring(startIndex).match(matcher)!;

        return {
            item: null,
            lastIndex: startIndex + match[0].length,
        }
    }
}
